export default "__VITE_ASSET__Ditwk6iU__"